import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';

type BillPresentmentDrawerOptionsInput = {
  isInDrawer: boolean;
  rootModalDrawer?: RootModalDrawerOptions;
};

export const getBillPresentmentRootModalDrawerOptions = ({
  isInDrawer,
  rootModalDrawer,
}: BillPresentmentDrawerOptionsInput): RootModalDrawerOptions | undefined => {
  if (!rootModalDrawer && !isInDrawer) {
    return undefined;
  }
  return rootModalDrawer ? { ...rootModalDrawer } : {};
};
